export const traHang = {
  sections: {
    list: { title: 'Trả hàng' },
    detail: { title: 'Chi tiết phiếu trả hàng' },
    traHang: 'Trả hàng',
    muaHang: 'Mua hàng',
  },
  titles: { add: 'Tạo phiếu trả hàng' },
  columns: {
    code: 'Mã phiếu',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
  },
  filter: { searchPlaceholder: 'Tìm theo mã phiếu trả...' },
  filters: {
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng',
    all: 'Tất cả',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    dateRange: 'Khoảng thời gian',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    status: 'Trạng thái',
    statusSection: 'Trạng thái phiếu',
    dateSection: 'Ngày giờ trả hàng',
    salesSection: 'Bán hàng',
    peopleSection: 'Người dùng',
    seller: 'Người bán',
    receiverReturn: 'Người nhận trả',
    deliverySection: 'Giao hàng',
    deliveryPartner: 'Đối tác giao hàng',
    deliveryArea: 'Khu vực giao hàng',
    deliveryStatus: 'Trạng thái giao hàng',
    otherIncomeType: 'Loại thu khác',
    returnType: 'Loại trả hàng',
    textDetailTitle: 'Bộ lọc trả hàng',
    khachHangPlaceholder: 'Tìm khách hàng',
    hintSection: 'Gợi ý',
    hintBody: 'Dùng ô tìm kiếm để lọc nhanh.',
    sortField: 'Sắp xếp theo',
    sortDir: 'Thứ tự',
    sortThoiGian: 'Thời gian',
    sortMaPhieu: 'Mã phiếu trả',
    sortCanTraKhach: 'Cần trả khách',
    sortTongTienHang: 'Tổng tiền hàng',
  },
  form: {
    code: 'Mã phiếu trả',
    codeAuto: 'Để trống tự sinh mã',
    customer: 'Khách hàng',
    retailCustomer: 'Khách lẻ',
    customerQuickAdd: 'Thêm nhanh khách hàng',
    channel: 'Kênh bán',
    returnFee: 'Phí trả hàng',
    bangGiaDefault: 'Bảng giá chung',
    tabLines: 'Chi tiết hàng hóa',
    note: 'Ghi chú',
    lines: 'Hàng trả',
    danhSachChiTiet: 'Danh sách chi tiết',
    addLine: 'Thêm dòng',
    product: 'Hàng hóa',
    maHang: 'Mã hàng',
    productName: 'Tên hàng',
    productSearch: 'Tìm mã / tên hàng',
    qty: 'Số lượng',
    qtyTra: 'SL trả',
    canTruCongNoHint: 'Hóa đơn còn nợ: {soTien} được cấn trừ vào công nợ, không trả tiền cho khách.',
    unitPrice: 'Đơn giá',
    discount: 'Giảm giá',
    discountPercent: 'Giảm (%)',
    discountShort: 'Giảm giá',
    salePrice: 'Giá bán',
    lineAmount: 'Thành tiền',
    lineNote: 'Ghi chú dòng',
    quickSearch: 'Tìm hàng trả (F3)',
    quickSearchDoi: 'Tìm hàng đổi (F7)',
    time: 'Thời gian',
    customerInfo: 'Thông tin trả hàng',
    sourceInvoice: 'Hóa đơn gốc',
    sourceInvoiceSearch: 'Tìm hóa đơn cần trả',
    sourceInvoiceEmpty: 'Chưa chọn hóa đơn',
    sourceInvoiceClear: 'Bỏ chọn hóa đơn',
    returnInfo: 'Chi tiết trả hàng',
    paymentMethod: 'Phương thức hoàn trả',
    orderNote: 'Ghi chú đơn hàng',
    refundAmount: 'Tiền trả khách',
    discountType: 'Loại giảm',
    discountValue: 'Giá trị giảm',
    openSourceInvoice: 'Chọn từ hóa đơn',
    byAmount: 'Theo số tiền',
    byPercent: 'Theo phần trăm',
    donViTinh: 'Đơn vị tính',
    giaBan: 'Giá bán',
    thanhTien: 'Thành tiền',
    bangGia: 'Bảng giá',
    creator: 'Người tạo',
    seller: 'Người bán',
  },
  messages: {
    loadError: 'Không tải được danh sách phiếu trả hàng.',
    deleteSuccess: 'Đã xóa phiếu.',
    createSuccess: 'Đã tạo phiếu trả hàng.',
    updateSuccess: 'Đã cập nhật phiếu trả hàng.',
    needLines: 'Vui lòng thêm ít nhất một dòng hàng.',
    noData: 'Không có phiếu trả hàng.',
    noLines: 'Không có dòng hàng.',
    listSummary: 'Tổng {count} phiếu',
    confirmDelete: 'Xóa phiếu {name}?',
    cancelSuccess: 'Đã hủy phiếu trả hàng.',
    confirmHuy: 'Hủy phiếu trả hàng {name}? Trạng thái sẽ được cập nhật thành Đã hủy.',
    refundSuccess: 'Đã ghi nhận hoàn trả.',
    invalidPayAmount: 'Số tiền hoàn trả không hợp lệ.',
    refundInlineSuccess: 'Đã tạo phiếu trả hàng + ghi nhận hoàn trả.',
    sourceInvoiceLoaded: 'Đã tải {count} dòng từ hóa đơn {code}.',
    sourceInvoiceNotFound: 'Không tìm thấy hóa đơn.',
    sourceInvoiceDaTraHet: 'Hóa đơn này đã trả hết số lượng mua — không còn dòng nào để trả.',
    error: 'Có lỗi xảy ra.',
    phieuXuatKhoFromReturn: 'Xuất bán theo phiếu trả {code}',
  },
  actions: {
    refund: 'Hoàn trả',
    cancelVoucher: 'Hủy phiếu',
    pay: 'Trả hàng',
    clear: 'Xóa',
    detail: 'Chi tiết',
    ketThuc: 'Kết thúc',
    xuLyDonHang: 'Xử lý đơn hàng',
    print: 'In',
    exportFile: 'Xuất file',
    dieuChinhCot: 'Điều chỉnh cột',
    copy: 'Sao chép',
    saoChep: 'Sao chép',
    taoPhieuXuatKho: 'Tạo phiếu xuất kho',
    capNhat: 'Cập nhật',
    dongY: 'Đồng ý',
    huyBo: 'Hủy bỏ',
  },
  fields: {
    totalAmount: 'Tổng tiền',
    refundedAmount: 'Đã hoàn trả',
    refundAmount: 'Số tiền hoàn trả',
    paymentMethod: 'Phương thức thanh toán',
    tongTienHangGoc: 'Tổng giá gốc hàng mua',
    tongTienHangTra: 'Tổng tiền hàng trả',
    giamGia: 'Giảm giá',
    phiTraHang: 'Phí trả hàng',
    hoanTraThuKhac: 'Hoàn trả thu khác',
    tongTienTra: 'Tổng tiền trả',
    tongTienMua: 'Tổng tiền mua',
    thuKhac: 'Thu khác',
    giaoHang: 'Giao hàng',
    canTraKhach: 'Cần trả khách',
    khachCanTra: 'Khách cần trả',
    khachNhanLai: 'Tiền trả khách',
    maHoaDonNguon: 'Từ hóa đơn',
    maPhieuNhapKho: 'Phiếu nhập kho',
    maPhieuXuatKho: 'Phiếu xuất kho',
    tenKhachHang: 'Khách hàng',
    khachHang: 'Khách hàng',
    maDatHang: 'Mã đặt hàng',
    maHoaDon: 'Mã hóa đơn',
    maPhieuTraHang: 'Mã phiếu trả',
    thoiGian: 'Ngày giờ trả',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    ngayDatHang: 'Ngày giờ trả',
    nguoiTao: 'Người tạo',
    nguoiBan: 'Người bán',
    nguoiNhanDat: 'Người nhận đặt',
    nguoiNhanTra: 'Người nhận trả',
    kenhBan: 'Kênh bán',
    trangThai: 'Trạng thái',
    loaiTraHang: 'Loại trả hàng',
    ghiChu: 'Ghi chú',
    bangGia: 'Bảng giá',
    tongTienHang: 'Tổng tiền hàng',
    giamGiaHoaDon: 'Giảm giá hóa đơn',
    phiShip: 'Phí ship',
    chiNhanh: 'Chi nhánh',
    chiNhanhXuLy: 'Chi nhánh xử lý',
    chiNhanhTao: 'Chi nhánh tạo',
    diaChiLayHang: 'Địa chỉ lấy hàng',
    nguoiNhan: 'Người nhận',
    dienThoai: 'Điện thoại',
    diaChi: 'Địa chỉ',
    khuVuc: 'Khu vực',
    phuongXa: 'Phường xã',
    ghiChuGiaoHang: 'Ghi chú giao',
    maVanDon: 'Mã vận đơn',
    trongLuong: 'Trọng lượng',
    kichThuoc: 'Kích thước',
    dichVu: 'Dịch vụ',
    nguoiGiaoDoiTac: 'Người giao',
    thuHoTienShort: 'Thu hộ tiền',
    phiTraDTGH: 'Phí trả ĐTGH',
    thoiGianGiaoHang: 'Hạn giao hàng',
    khachDaTra: 'Khách đã trả',
    yeuThich: 'Yêu thích',
    actions: 'TT',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  detailTabs: {
    chung: 'Chung',
    generalInfo: 'Thông tin',
    chiTietDonHang: 'Chi tiết đơn hàng',
  },
  summary: {
    tongTienHangCount: 'Tổng tiền hàng ({count})',
    tongSoLuong: 'Tổng số lượng',
    tongTienHang: 'Tổng tiền hàng',
    giamGiaPhieuDat: 'Giảm giá',
    tongCong: 'Tổng cộng',
    hangSuaChua: 'Hàng sửa chữa',
  },
  status: {
    MOI_TAO: 'Mới tạo',
    HOAN_THANH: 'Hoàn thành',
    DA_HUY: 'Hủy',
  },
  loaiTraHang: {
    THEO_HOA_DON: 'Theo hóa đơn',
    TRA_NHANH: 'Trả nhanh',
    CHUYEN_HOAN: 'Chuyển hoàn',
  },
  paymentMethod: {
    TIEN_MAT: 'Tiền mặt',
    THE: 'Thẻ',
    VI: 'Ví',
    CHUYEN_KHOAN: 'Chuyển khoản',
  },
  pos: {
    addTab: 'Thêm tab trả hàng',
    tabTitle: 'Trả hàng {n}',
    tabEdit: 'Sửa {code}',
    tabClone: 'Nhái {code}',
    tabFromInvoice: 'Theo HD {code}',
    history: 'Lịch sử trả hàng',
    confirmCloseTitle: 'Đóng tab?',
    confirmCloseBody: 'Dữ liệu chưa lưu sẽ mất. Tiếp tục?',
    openEdit: 'Sửa phiếu này',
    openClone: 'Tạo bản nhái',
    openFromInvoice: 'Trả hàng theo hóa đơn này',
    newTabHoaDon: 'Hóa đơn mới',
    newTabTraHang: 'Trả hàng mới',
    filterAll: 'Tất cả',
    filterHoaDon: 'Hóa đơn',
    filterTraHang: 'Trả hàng',
    viewFullList: 'Xem danh sách đầy đủ',
  },
  placeholders: {
    formTitle: 'Tạo / sửa phiếu trả hàng',
    formBody: 'Biểu mẫu đầy đủ sẽ được bổ sung theo nghiệp vụ.',
    ghiChu: 'Ghi chú...',
    ghiChuGiao: 'Ghi chú giao...',
    chonDoiTac: 'Chọn đối tác...',
  },
  sourceInvoicePicker: {
    title: 'Chọn hóa đơn trả hàng',
    searchSection: 'Tìm kiếm',
    maHoaDon: 'Theo mã hóa đơn',
    maKhachHang: 'Theo mã khách hàng',
    tenKhachHang: 'Theo tên khách hàng',
    maHang: 'Theo mã hàng',
    tenHang: 'Theo tên hàng',
    timeSection: 'Thời gian',
    timeAll: 'Toàn thời gian',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    sellerSection: 'Người bán',
    sellerPlaceholder: 'Chọn người bán',
    statusSection: 'Trạng thái hóa đơn',
    hint: 'Chỉ hiện hóa đơn chưa hủy của chi nhánh đang làm việc.',
    choose: 'Chọn',
    noData: 'Không tìm thấy hóa đơn phù hợp.',
    summary: 'Tổng {count} hóa đơn',
    columns: {
      maHoaDon: 'Mã hóa đơn',
      thoiGian: 'Thời gian',
      khachHang: 'Khách hàng',
      nguoiBan: 'Người bán',
      trangThai: 'Trạng thái',
      tongTienHang: 'Tổng tiền hàng',
      khachCanTra: 'Khách cần trả',
      khachDaTra: 'Khách đã trả',
    },
  },
}
